import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NgbDate, NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { DayTemplateContext } from '@ng-bootstrap/ng-bootstrap/datepicker/datepicker-day-template-context';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-struct';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgbDatepicker],
})
export class DatepickerComponent {
  @Input() public displayMonths: number = 1;
  @Input() public outsideDays: 'visible' | 'collapsed' | 'hidden' = 'visible';
  @Input() public navigation: 'select' | 'arrows' | 'none' = 'select';
  @Input() public dayTemplate: TemplateRef<DayTemplateContext> | undefined =
    undefined;
  @Input() public minDate: NgbDateStruct | undefined = undefined;
  @Input() public maxDate: NgbDateStruct | undefined = undefined;

  @Output() public dateSelect: EventEmitter<NgbDate> =
    new EventEmitter<NgbDate>();

  @ViewChild('dp') datepicker: NgbDatepicker;
}
